<template lang="html">
  <div class="ui main container">
    <div class="ui grid">
      <div class="seven wide column">
        <div class="ui segment">
          <ProductZoomer
            :base-images="images"
            :base-zoomer-options="zoomerOptions"
          />
        </div>
      </div>
      <div class="seven wide column">
        <div class="ui segment">
          <h2 class="ui header">
            Camisa Rayada
            <div class="sub header">Scappino</div>
          </h2>
          <p class="ui medium">
            Esta es la descripcion del producto puede ser un texto muy largo o
            algo muy sencillo pero debe verse bien
          </p>
          <h4>Precio: <b style="color: red;">$ 125.50</b></h4>
          <h4>Tamaño</h4>

          <p>
            <sui-dropdown
              placeholder="Tamaño"
              selection
              :options="options"
              v-model="current"
            />
          </p>
          <h4>Cantidad</h4>
          <div class="ui input input-custom">
            <input type="number" placeholder="1" />
          </div>
          <h4></h4>
          <div class="">
            <button class="ui blue button icon" type="button">
              <i class="ui cart icon"></i>
              Agregar al carrito
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Test',
  data() {
    return {
      current: null,
      options: [
        {
          text: 'S',
          value: 1
        },
        {
          text: 'M',
          value: 2
        },
        {
          text: 'L',
          value: 2
        }
      ],
      images: {
        thumbs: [
          {
            id: 1,
            url:
              'https://www.yoohooworld.com/assets/images/vue_product_zoomer/thumbs/3.jpeg'
          },
          {
            id: 2,
            url:
              'https://www.yoohooworld.com/assets/images/vue_product_zoomer/thumbs/8.jpeg'
          }
        ],
        normal_size: [
          {
            id: 1,
            url:
              'https://www.yoohooworld.com/assets/images/vue_product_zoomer/normal_size/3.jpeg'
          },
          {
            id: 2,
            url:
              'https://www.yoohooworld.com/assets/images/vue_product_zoomer/normal_size/8.jpeg'
          }
        ]
      },
      zoomerOptions: {
        zoomFactor: 3,
        pane: 'pane',
        hoverDelay: 300,
        namespace: 'zoomer-left',
        move_by_click: false,
        scroll_items: 5,
        choosed_thumb_border_color: '#dd2c00',
        scroller_position: 'bottom',
        zoomer_pane_position: 'right'
      }
    };
  }
};
</script>

<style lang="css">
.responsive-image:not(.preview-box):not(.zoomer-control) {
  max-height: 50px;
  max-width: 50px;
}
.zoomer-control {
  max-height: 28.5px;
  max-width: 28.5px;
}
.input-custom {
  max-width: 70px !important;
}
</style>
